import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DemoUiService } from '../../core/demo-ui.service';
import { SECTION_COMPONENTS } from '../../shared/compound/section.components';
@Component({ selector: 'rv-technology', standalone: true, imports: [...SECTION_COMPONENTS], templateUrl: './technology.component.html', changeDetection: ChangeDetectionStrategy.OnPush })
export class TechnologyComponent { readonly ui = inject(DemoUiService); }
